export const Pages = {
  LANDING_PAGE: {
    path: "/",
    title: "One link or QR code to apps on App Store and Google Play",
  },
  ABOUT: { path: "/about-onelink-to", title: "About" },
  MY_ONELINKS: { path: "/my-onelinks", title: "My Onelinks" },
  NEWS: { path: "/news", title: "News" },
  SUPPORT: { path: "/support", title: "Support & FAQ" },
  CONTACT: { path: "/contact-us", title: "Contact Us" },
  REGISTER: { path: "/signup", title: "Sign Up" },
  SIGNIN: { path: "/login", title: "Login" },
  COMPLETE_REGISTRATION: {
    path: "/setup/complete-registration",
    title: "Complete Registration",
  },
  SETUP_PAYMENT: { path: "/payment-setup", title: "Setup Payment" },
  PAYMENT_SUCCESS: { path: "/payment-success", title: "Payment Successful" },
  PAYMENT_CANCELLED: { path: "/payment-cancelled", title: "Payment Cancelled" },
  RESET_PASSWORD: { path: "/user/reset-password", title: "Reset Password" },
  USER_SETTINGS: { path: "/user/settings", title: "User Settings" },
  VERIFY_EMAIL: { path: "/user/verify-email", title: "Verify Email" },
  INVITATION: { path: "/user/invitation", title: "Invitation" },
  ACCOUNT: { path: "/account", title: "My Account" },
  PRICING: { path: "/pricing", title: "Pricing" },
  MANAGE_ACCESS: { path: "/account/manage-access", title: "Manage Access" },
  TERMS_OF_SERVICE: { path: "/legal/terms", title: "Terms of Service" },
  PRIVACY_POLICY: { path: "/legal/privacy", title: "Privacy Policy" },
  LEGAL_NOTICE: { path: "/legal/notice", title: "Legal Notice" },
};

export const PATHS_PENDING_ACCOUNT = [
  Pages.LANDING_PAGE.path,
  Pages.NEWS.path,
  Pages.SUPPORT.path,
  Pages.COMPLETE_REGISTRATION.path,
  Pages.VERIFY_EMAIL.path,
  Pages.RESET_PASSWORD.path,
  Pages.INVITATION.path,
  Pages.PRICING.path,
  Pages.TERMS_OF_SERVICE.path,
  Pages.PRIVACY_POLICY.path,
  Pages.LEGAL_NOTICE.path,
];

export const PATHS_PRERENDER_INDEX = [
  Pages.LANDING_PAGE.path,
  Pages.SUPPORT.path,
  Pages.PRICING.path,
  Pages.TERMS_OF_SERVICE.path,
  Pages.PRIVACY_POLICY.path,
  Pages.LEGAL_NOTICE.path,
];

const exports = {
  PATHS_PENDING_ACCOUNT,
  PATHS_PRERENDER_INDEX,
};

export default exports;
